import { useToast } from "@/hooks/useToast";
import { IS_MOBILE } from "@/lib/environmentDetector";
import { muteChat, unmuteChat } from "@/middleware/chats";

import MobileChatMenu from "./MobileChatMenu";
import DesktopChatMenu from "./DesktopChatMenu";
import { useNavigationState } from "@/zustand/NavigationState";

import { useTranslation } from "react-i18next";

export default function ChatMenu() {
  const { t } = useTranslation();

  const activeChatId = useNavigationState((state) => state.activeChatId);

  const { toast } = useToast();

  const handleMuteChat = async () => {
    if (!activeChatId) {
      return;
    }
    try {
      await muteChat(activeChatId);
    } catch (error) {
      toast({
        duration: 1000,
        description:
          error instanceof Error ? error.message : t("errorOccurred"),
        variant: "destructive",
      });
    }
  };

  const handleUnMuteChat = async () => {
    if (!activeChatId) {
      return;
    }
    try {
      await unmuteChat(activeChatId);
    } catch (error) {
      toast({
        duration: 1000,
        description:
          error instanceof Error ? error.message : t("errorOccurred"),
        variant: "destructive",
      });
    }
  };

  if (IS_MOBILE) {
    return (
      <MobileChatMenu onMute={handleMuteChat} onUnMute={handleUnMuteChat} />
    );
  }
  return (
    <DesktopChatMenu onMute={handleMuteChat} onUnMute={handleUnMuteChat} />
  );
}
